import moment from 'moment';
/**时间排序 */
export function sortTime(firstVal: any, secondVal: any) {
  const firstTime = moment(firstVal).valueOf();
  const secondTime = moment(secondVal).valueOf();
  if (firstTime < secondTime) return 1;
  if (firstTime > secondTime) return -1;
  return 0;
}

/**默认排序 */
export function sorter(firstVal: any, secondVal: any) {
  // 无效/占位与缺数统一按 +Infinity，与 tableUtils.isMetricSortValueMissing 对齐，沉底而非顶头
  if ((!firstVal && firstVal != 0) || isNaN(parseInt(firstVal))) {
    firstVal = Number.POSITIVE_INFINITY;
  }
  if ((!secondVal && secondVal != 0) || isNaN(parseInt(secondVal))) {
    secondVal = Number.POSITIVE_INFINITY;
  }
  if (parseFloat(firstVal) > parseFloat(secondVal)) return 1;
  if (parseFloat(firstVal) < parseFloat(secondVal)) return -1;
  return 0;
}

/**排名排序：降序为1 2 3 ，升序为 3 2 1 */
export function sortRank(firstVal: any, secondVal: any) {
  firstVal = Math.abs(+firstVal);
  secondVal = Math.abs(+secondVal);
  if (firstVal > secondVal) return -1;
  if (firstVal < secondVal) return 1;
  return 0;
}

/**排名环比排序：升序应该是从小到大那应该是红的(-n)在前面绿的(+n)在后面，降序的话从大到下就是绿的在前红的在后 */
export function sorterRankChange(firstVal: any, secondVal: any) {
  const _firstVal = Math.abs(+firstVal);
  const _secondVal = Math.abs(+secondVal);
  if (_firstVal > _secondVal) return 1;
  if (_firstVal < _secondVal) return -1;
  if (firstVal > secondVal) return 1;
  if (firstVal < secondVal) return -1;
  return 0;
}
